import { CheckboxGroupInput, ReferenceArrayInput } from "react-admin";

import React from "react";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core";

// record -> input
const format = (sensorTypes) => {
  let formattedData = sensorTypes
    ? sensorTypes.map((g) => g.sensor_type_id.toString())
    : [];
  return formattedData;
};

// input -> record
const parse = (sensorTypes) => {
  let parsedData = sensorTypes
    ? sensorTypes.map((id) => ({ sensor_type_id: id.toString() }))
    : [];
  return parsedData;
};

const Checkboxes = ({ ...props }) => (
  <CheckboxGroupInput style={{ width: "100%" }} {...props} />
);

const SensorTypeInput = withStyles((theme) => ({
  root: {
    width: "100%",
    "& legend": {
      fontSize: 20,
      marginBottom: theme.spacing.unit * 0.5,
    },
    "& div": {
      borderTopColor: grey[300],
      borderTopStyle: "solid",
      borderTopWidth: 1,
      paddingTop: theme.spacing.unit,
    },
    "& label[for]": {
      width: 250,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    "& label[for] > span:first-child": {
      display: "flex",
      alignSelf: "flex-start",
    },
    "& label[for] > span:nth-child(2)": {
      marginTop: theme.spacing.unit * 0.5,
      alignSelf: "normal",
    },
  },
}))(({ classes, ...props }) => (
  <ReferenceArrayInput
    {...props}
    format={format}
    parse={parse}
    reference="sensor-type"
    className={classes.root}
  >
    <Checkboxes />
  </ReferenceArrayInput>
));

export default SensorTypeInput;
